export default class MapBase {
    isMouseInHoverCircle() {
        //if (MpointHoverCircle.hoverMpoint) {
        //    const mpointMarker = ViewState.mPointMarkers.find(mp => mp._mpoint.id === MpointHoverCircle.hoverMpoint.id);
        //    if (mpointMarker) {
        //        const overlay = this.overlay;
        //        const node = overlay.node();
        //        const mouseCoord = d3.mouse(node);
        //        //aktuell mpoint marker har pointer-events på för att fånga click -> utlöser denna mouseleave
        //        return Positioning.arePointsWithinMargin({ x: mouseCoord[0], y: mouseCoord[1] }, { x: mpointMarker.x, y: mpointMarker.y }, LookAndStyle.RADIUS_HOVER_CIRCLE + 5);
        //    }
        //}
        return false;
    }
}
